<template>
  <!-- 转让出租列表 -->
  <div class="product-images">
    <div :class="isSearch?'box box-3':'box box-4'" v-for="item in list" :key="item.id" @click="onDetail(item)">
      <div>
        <div class="state" v-if="isState && item.type == 1" :style="activation(item.status)">
          {{ item.status == 2 ? '交易中' : '已成交' }}
        </div>
        <div class="image-info">
          <img class="box-image" :src="config.domainUrl + item.cover" alt="" />
        </div>

      </div>
      <div class="detailed-info">
        <div class="title">{{ item.title }}</div>
        <div class="area-price">
          <div class="area">
            <span class="iconfont icon-area">{{ item.area }}</span>
          </div>
          <div class="price">{{ item.starting_price > 0 ? item.starting_price : '面议' }}</div>
        </div>

        <div class="use-position">
          <div class="use">
            <span class="iconfont icon-useland">{{ item.use_type_name }}</span>
          </div>
          <div class="position">
            <span class="iconfont icon-position">{{ item.address }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 数据为空 -->
    <el-empty v-if="list.length <= 0" style="width: 100%;" description="暂无数据" />
  </div>
</template>

<script setup>
import router from "@/router";
import { reactive, computed, defineProps } from "vue";
import config from "@/global-config";


const props = defineProps({
  //子组件接收父组件传递过来的值
  list: Array,
  isState: Boolean,
  isPledeg: Boolean,
  isSearch:{
    type:Boolean,
    default:false
  }
})

// 根据接收不同状态显示不同背景颜色
const activation = computed((activation) => {
  return (state) => {
    // console.log(state)
    if (state === 2) {
      return {
        background: "#349BF9",
      };
    } else {
      return {
        background: "#F93434",
      };
    }
  };
});

const onDetail = (val) => {
  router.push(`/resource-info-detail?id=${val.id}&&type=${val.type}`)
}
</script>

<style scoped lang="less">
.product-images {
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  // margin-top: 1.875rem;
  // width: 88rem;
  // height: 82rem;
  background: #ffffff;
  // padding: 1.25rem 0;
  padding: 1.42rem 1.42rem 0 1.42rem;

  .box {
    position: relative;
    width: 20rem;
    height: 19rem;
    margin-bottom: 1.25rem;

    overflow: hidden;
    margin-right: 0.7rem;

    .state {
      position: absolute;
      left: 0.625rem;
      top: 0.625rem;
      width: 5rem;
      height: 2rem;
      border-radius: 5rem;
      text-align: center;
      line-height: 2rem;
      z-index: 1;
      color: #ffffff;
    }

    .image-info {
      width: 20rem;
      height: 12.5rem;
      overflow: hidden;

      .box-image {
        width: 20rem;
        height: 12.5rem;
        cursor: pointer;
        transition: all 0.6s;
      }

      .box-image:hover {
        transform: scale(1.4);
      }
    }

    .detailed-info {
      width: 20rem;
      height: 6.5rem;
      background: #f5f5f5;
      overflow: hidden;

      .title {
        margin: 0.625rem 0.728rem;
        font-size: 1.12rem;
        font-weight: normal;
      }

      .area-price {
        display: flex;
        justify-content: space-between;
        margin: 0 0.728rem 0.5rem 0.728rem;

        .icon-area {
          font-size: 0.75rem;
          color: #999999;
        }

        .price {
          font-size: 1.125rem;
          font-weight: bold;
          color: #f93434;
        }
      }

      .use-position {
        display: flex;
        justify-content: space-between;
        margin: 0 0.728rem 0 0.728rem;
        color: #999999;

        .icon-useland {
          font-size: 0.75rem;
          margin-left: 0;
        }

        .icon-position {
          font-size: 0.75rem;
          margin-right: 0;
        }
      }
    }
  }

  .box-4:nth-child(4n) {
    margin-right: 0;
  }
  .box-3:nth-child(3n) {
    margin-right: 0;
  }
}

.pledeg {
  /deep/.el-table__header {
    height: 4.428rem;
  }

  /deep/.el-table .cell {
    padding-left: 40px;
    color: #333333;
  }
}
</style>
